// extracted by mini-css-extract-plugin
module.exports = {"main":"gear_main__lHjjR","textOrange":"gear_textOrange__1EGrY"};